import { useMember } from "api/members";
import { useTiers } from "api/tiers";
import { useAppSelector } from "app/hooks";
import { useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import { getTenantSettings } from "reduxState/settings/settings";
import { TiersSection } from "./TiersSection";

export function Tiers() {
  const { id: memberID } = useParams<{ id: string; page: string }>();
  const { useMembersData, useMembersStatus } = useMember(memberID);
  const { data: membersData } = useMembersData();
  const { data: membersStatus } = useMembersStatus();
  const settings = useAppSelector(getTenantSettings);
  const tiersMode = settings?.tiersMode;
  const [selectedTierSetId, setSelectedTierSetId] = useState<string>();
  const { useListOfTierSets } = useTiers();
  const { data: tierSetList } = useListOfTierSets();
  const { useTierSetTiers } = useTiers();
  const { data: tierSetTiers } = useTierSetTiers(selectedTierSetId);
  const manuallyAssignedTier =
    membersData && membersData.manuallyAssignedLevelId
      ? tierSetTiers?.items?.find(
          (tier) => tier.levelId === membersData?.manuallyAssignedLevelId,
        )
      : undefined;

  useEffect(() => {
    setSelectedTierSetId(tierSetList?.items[0]?.tierSetId);
  }, [tierSetList?.items]);

  return (
    <TiersSection
      membersStatus={membersStatus}
      settings={settings}
      tiersMode={tiersMode}
      selectedTierSetId={selectedTierSetId}
      setSelectedTierSetId={setSelectedTierSetId}
      tierSetList={tierSetList?.items}
      manuallyAssignedTier={manuallyAssignedTier}
    />
  );
}
